import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import { NEON_LIGHT_TEXTURE_KEYS, NEON_LIGHTS_ATLAS_FRAMES } from './constants'

export const NeonLightsTexturePreloader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_HIT_TRANSITION)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.NUMBER_LIT_UP)) {
    scene.textures.addSpriteSheetFromAtlas(NEON_LIGHT_TEXTURE_KEYS.NUMBER_LIT_UP, {
      atlas: NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      frame: NEON_LIGHTS_ATLAS_FRAMES.NUMBER_LIT_UP,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }
}
